export enum ToastButtons {
    None,
    YesNo,
    OkCancel,
    Ok
}